export default __webpack_public_path__ + "static/media/Sedan.e963fb74.svg";